var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1531 12.1115C13.1531 14.9344 10.8802 17.2228 8.07663 17.2228C5.27305 17.2228 3 14.9344 3 12.1115C3 9.28857 5.27288 7 8.07663 7C10.8804 7 13.1531 9.28857 13.1531 12.1115ZM18.7221 12.1116C18.7221 14.7688 17.5857 16.9237 16.1838 16.9237C14.782 16.9237 13.6455 14.7688 13.6455 12.1116C13.6455 9.45446 14.7818 7.29956 16.1837 7.29956C17.5855 7.29956 18.722 9.45377 18.722 12.1116H18.7221ZM20.1073 16.4223C20.6004 16.4223 21 14.4917 21 12.1115C21 9.73065 20.6002 7.80066 20.1073 7.80066C19.6143 7.80066 19.2147 9.73083 19.2147 12.1115C19.2147 14.4922 19.6142 16.4223 20.1073 16.4223Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.de8474239e1efc4a0b0456152068af17.svg";
export { ForwardRef as ReactComponent };